import { FirebaseAuthentication } from 'services/firebase';

const loginWithEmailAndPassword = async (email, password) => {
  try {
    const userCredential = await FirebaseAuthentication().signInWithEmailAndPassword(
      email,
      password
    );
    const { user } = userCredential;

    return user.emailVerified;
  } catch (error) {
    const { code } = error;

    switch (code) {
      case 'auth/invalid-email':
        throw new LoginEmailPasswordError({
          email: 'Email address is invalid',
        });

      case 'auth/user-not-found':
        throw new LoginEmailPasswordError({
          email: 'There is no user with the given email',
        });

      case 'auth/wrong-password':
        throw new LoginEmailPasswordError({ password: 'Wrong password' });

      default:
        throw error;
    }
  }
};

export class LoginEmailPasswordError {
  constructor(errors) {
    const { email = '', password = '' } = errors;

    this.email = email;
    this.password = password;
  }
}

export default loginWithEmailAndPassword;
